<template>
  <div class="login-style contentArea">
    <div class="cus-position">
      <div class="flex justify-center">
        <img src="@/assets/images/logo/logo_FAstation.svg" />
      </div>
      <br />
      <br />
      <form @submit.prevent="LoginAdmin($event)">
        <vs-input
          placeholder="อีเมล"
          icon="mail"
          class="w-full logininput"
          type="email"
          v-model="email"
          required
        />
        <br />
        <br />
        <vs-input
          placeholder="รหัสผ่าน"
          icon="lock"
          type="password"
          v-model="password"
          class="w-full logininput"
          required
        />
        <br />

        <!-- <a class="forgetpass" href=">">ลืมรหัสผ่าน?</a> -->
        <br /><br />
        <div class="flex justify-center">
          <button class="login-btn">ล็อคอิน</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from "../../util/backend";
export default {
  data() {
    return {
      email: null,
      password: null
    };
  },
  methods: {
    async LoginAdmin() {
      this.$vs.loading();
      await api
        .login(this.email, this.password)
        .then(async res => {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("refresh_token", res.data.RefreshToken);
          await this.$store.commit("general/COLLECT_TOKEN", {
            token: res.data.token,
            refresh_token: res.data.RefreshToken
          });
          await this.$store.commit("general/GET_ADMIN_INFO", res.data.data);
          this.$vs.loading.close();
          this.$router.push({ path: "/" });
        })
        .catch(err => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "error message",
            text: `${err.response.data.error ? err.response.data.error : err}`,
            color: "danger",
            icon: "error",
            position: "top-right"
          });
        });
    }
  }
};
</script>

<style lang="scss">
.forgetpass {
  font-size: 1.2rem;
  background: -webkit-linear-gradient(#007afe, #013f81);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
  justify-content: end;
}

.login-style {
  // background-image: url("../../../src/assets/images/bg/AdminBG.png");
  // background-size: cover;
  background-color: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  height: 100vh;
  justify-content: center;
}
.cus-position {
  width: 30%;
}

.input-style {
  border: none;
  border-radius: 8px;
  background-color: #ededed;
}

.login-btn {
  font-size: 1.2rem;
  padding: 0.5rem 3rem;
  background-color: #305eb3;
  color: white;
  border-radius: 15px;
  border: none;
}

.logininput {
  color: #434343 !important;
}

.logininput .vs-icon {
  line-height: 1.6 !important;
  padding-left: 0.5rem;
  border: none;
}

.logininput .vs-input--placeholder {
  color: #434343 !important;
}

.logininput .vs-con-input .vs-inputx {
  background-color: #ededed;
  border: none !important;
}
</style>
